import { DAYS_PER_MONTH } from './digitContants'

export const getUnit = (amount: number | undefined) => {
	if (Number(amount) >= 1) {
		return `${Number(amount)} kg`
	} else {
		return `${Number(amount) * 1000} g`
	}
}

export const formatPackLabel = (label: string | undefined) => {
	if (label?.includes('x')) {
		const splitArr = label?.split('x')
		const amountNumber = Number(splitArr[1].replace(',', '.'))
		const amountWithUnit = amountNumber >= 1 ? `${amountNumber} kg` : `${amountNumber * 1000} g`

		return `${splitArr[0]} x ${amountWithUnit.replace('.', ',')}`
	} else {
		const amountLabel = Number(label?.replace(',', '.'))
		return `${getUnit(amountLabel).replace('.', ',')}`
	}
}

export const pricePerMonth = (
	dailyDose: number,
	pack: {
		price?: number | undefined
		heurekaPrice?: number | undefined
		amount: number | undefined
		id: string
	},
) => {
	const monthlyDose = dailyDose * DAYS_PER_MONTH

	const price = pack.heurekaPrice ?? pack.price
	if (pack.amount && price) {
		const packSize = pack.amount * 1000 // to grams
		const lastingForMonths = packSize / monthlyDose
		const result = price / lastingForMonths
		return result
	}
}

export const dailyPrice = (
	dailyDose: number,
	pack: {
		price?: number | undefined
		heurekaPrice?: number | undefined
		amount: number | undefined
		id: string
	},
) => {
	const price = pack.heurekaPrice ?? pack.price
	if (pack.amount && price) {
		const packSize = pack.amount * 1000 // to grams
		const result = (dailyDose * price) / packSize

		return Math.round(result)
	}
}
